import React from "react";
import Item from "./Item";
import { ColumnProps } from "../../../../../types/types";
import { Button, Box, TextInput } from "@mantine/core";

const Column: React.FC<ColumnProps> = ({
  col: { list, id },
  ...props
}: any) => {
  const Columns = (props.currentReportComponent === "viewReport" && props.diffrentQueryForViewReportFlag === "no") ? props.columnsViewReport : props.columns;
  const addNewItem = () => {
    props.setShowInputAddQueryColumn(true);
  };

  //sets the entered column name to state
  const handleChange = (event: any) => {
    const value = event.target.value;
    props.setValueAddQueryColumn(value);
  };

  //sets the new query column name to the list and updates the column state
  const handleSave = () => {
    if (props.valueAddQueryColumn !== "") {
      Columns["Query_Columns"].list.push(props.valueAddQueryColumn);
    }
    props.setShowInputAddQueryColumn(false);
    props.currentReportComponent === "viewReport" ? props.setColumnsViewReport(Columns) : props.setColumns(Columns);
    props.setValueAddQueryColumn("");
  };

  return (
    <div
      style={{
        padding: "24px 16px",
        display: "flex",
        flexDirection: "column",
        marginTop: 8,
        width: "100%",
      }}
    >
      <h2 style={{ margin: 0, padding: "0 16px" }}>{id}</h2>

      <div
        style={{
          backgroundColor: "#e2f6ec",
          borderRadius: 8,
          maxHeight: "80%",
          padding: 16,
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          marginTop: 8,
          width: "20rem",
        }}
      >
        <Box
          sx={() => ({
            overflow: "auto",
          })}
        >
          {/* displays all the query columns present in the list and calls Item component for each column */}
          {list?.map((text: any, index: any) => (
            <Item key={text} text={text} index={index} id={id} {...props} />
          ))}
        </Box>

        {/* shows add query column only in the query_column list */}
        {id === "Query_Columns" && (
          <Button
            style={{
              padding: 8,
              width: "100%",
              margin: "8px 0",
              backgroundColor: "#12b886",
              borderColor: "#12b886",
            }}
            onClick={addNewItem}
          >
            Add query column
          </Button>
        )}
      </div>

      {/* on clicking add new query column, sets show input to true and an input box appears */}
      {props.showInputAddQueryColumn && id === "Query_Columns" && (
        <Box
          sx={() => ({
            display: "flex",
            flexDirection: "column",
          })}
        >
          <TextInput
            placeholder="Enter query column"
            label="Enter query column"
            name="query_column"
            value={props.valueAddQueryColumn}
            onChange={handleChange}
          />
          <Button style={{ backgroundColor: "#12b886" }} onClick={handleSave}>
            Add
          </Button>
        </Box>
      )}
    </div>
  );
};

export default Column;
